import { PRODUCTS, APPLE_PRODUCT_IDS, APPLE_TO_INTERNAL } from '../constants/subscription';
import * as appleProvider from '../services/appleProvider';

export { APPLE_TO_INTERNAL };

export function getPlatform() {
  if (typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.()) {
    return 'ios';
  }
  return 'web';
}

export function getPlans() {
  // Annual leads (default CTA); monthly stays as the visible anchor that makes
  // the saving real. Prices come from StoreKit when loaded so the paywall
  // always matches the storefront's actual charge/currency; the hardcoded GBP
  // strings are the pre-load fallback only.
  const yearlyLive = appleProvider.getLocalizedPricing?.(PRODUCTS.PREMIUM_YEARLY) || null;
  const monthlyLive = appleProvider.getLocalizedPricing?.(PRODUCTS.PREMIUM_MONTHLY) || null;

  return [
    {
      id: PRODUCTS.PREMIUM_YEARLY,
      name: 'Yearly',
      price: yearlyLive?.price || '£19.99',
      period: '/year',
      perMonth: `${yearlyLive?.perMonth || '£1.67'}/month, billed annually`,
      highlighted: true,
      badge: 'Best Value',
      savings: 'Save 76% vs monthly',
      trial: yearlyLive ? (yearlyLive.hasTrial ? '1 month free' : null) : '1 month free',
      cta: 'Start 1 Month Free',
    },
    {
      id: PRODUCTS.PREMIUM_MONTHLY,
      name: 'Monthly',
      price: monthlyLive?.price || '£6.99',
      period: '/month',
      highlighted: false,
      badge: null,
      cta: 'Choose Monthly',
    },
  ];
}

// Buy a tier. Throws Error('canceled') for user cancel — UI should not toast.
export async function purchase(tier) {
  const platform = getPlatform();

  if (platform === 'ios') {
    if (!APPLE_PRODUCT_IDS[tier]) {
      throw new Error('This plan is not available on iOS. Please subscribe on the web.');
    }
    if (!appleProvider.isAvailable()) {
      throw new Error('In-app purchases are not available in this build.');
    }
    return appleProvider.purchaseProduct(tier);
  }

  // Web has no purchase path — Apple IAP is the only way to subscribe.
  throw new Error('Subscriptions are available in the Recall iOS app.');
}

export async function openManagement() {
  // Apple is the only payment provider — deep-link to iOS subscription management.
  window.open('https://apps.apple.com/account/subscriptions', '_blank');
}

export async function restore() {
  if (getPlatform() === 'ios') {
    await appleProvider.restorePurchases();
  }
}
